import React, { useState } from 'react';
import { signInAnonymously } from '../../constants';
// Custom components
import { DefaultButton } from '../Buttons';
// Material components
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';

export default function AnonSignIn() {

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(open ? false : true);
    };

    const handleSubmit = () =>{
        signInAnonymously(handleOpen)
    }

    return (
        <div>
            <DefaultButton
                variant="light"
                onClick={handleOpen}>
                Sign in anonymously
            </DefaultButton>
            <Dialog open={open} onClose={handleOpen} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Are you sure?</DialogTitle>
                <DialogContent>
                    Things you will miss out on...
                    <ul>
                        <li>Create your own stories</li>
                        <li>Add more frequently to all stories</li>
                        <li>Customize website style</li>
                    </ul>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant='outlined'
                        onClick={handleSubmit}
                        color="primary">
                        Confirm
                    </Button>
                    <Button
                        variant='outlined'
                        onClick={handleOpen}
                        color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    );
}